import useEsgAdminFeaturesVisible from "hooks/useEsgAdminFeaturesVisible";

/**
 * Only show the child components to ESG_ADMIN users who currently have admin features
 * toggled on (header icon, EsgAdminViewToggle). An ESG Admin can hide this content without
 * losing the role - see useEsgAdminFeaturesVisible.
 *
 * Use-case: internal diagnostics that must not reach a normal user - e.g. the raw
 * check-failure detail (check name + exception text) behind a "could not be generated" report
 * section placeholder (ESG-3953). That detail can contain internal identifiers (UUIDs,
 * Weaviate collection names, check names) which is exactly why it isn't in the report body -
 * it's gated here instead.
 *
 * Sibling of DevOnly (gated on the DEV role) - shares the same toggle.
 */
export default function EsgAdminOnly({ children, style }) {
  const showAdminFeatures = useEsgAdminFeaturesVisible();
  if (showAdminFeatures) {
    return (
      <div className="EsgAdminOnly" style={style}>
        {children}
      </div>
    );
  }
  return null;
}
